import React, { Component } from 'react';
import { Modal, Table, Button, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class UserInfo extends Component {
    state = {
        visible: false,
        investigation: {},
        userDetail: {},
        data: [],
        user: {},
        loading: false,
    }

    queryUserData = (userId) => {
        const options = {
            method: 'POST',
            url: API_URL.team.queryuser,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { user, clinicalTrialExperienceYears } = res;
                this.setState({
                    user: {
                        ...user,
                        clinicalTrialExperienceYears,
                    },
                });
            },
        };
        $.sendRequest(options);
    }

    loadData = (userId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeClinicalExperience,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;

                this.setState({
                    loading: false,
                    data,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    show = userId => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData(userId);
            this.queryUserData(userId);
        });
    }

    hide = () => {
        this.setState({
            user: {},
            data: [],
            visible: false,
        });
    }

    getColumns = () => [{
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 80,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 120,
    }, {
        title: '项目角色',
        dataIndex: 'clinicalRoleName',
        key: 'clinicalRoleName',
        width: 80,
    }, {
        title: '项目类型',
        dataIndex: 'clinicalTypeName',
        key: 'clinicalTypeName',
        width: 100,
    }, {
        title: '参与时间',
        dataIndex: 'joinTime',
        key: 'joinTime',
        width: 120,
    }, {
        title: '研究产品类型',
        dataIndex: 'investigationProductName',
        key: 'investigationProductName',
        width: 120,
    }, {
        title: '项目分期',
        dataIndex: 'investigationProductStageName',
        key: 'investigationProductStageName',
    }]
    
    getDataSource = () => {
        const { data } = this.state;
        const isChinese = true;
        const dataSource = data.map((item, index) => {
            const {
                investigationAreaName,
                investigationAreaEnglishName,
                diseaseName,
                diseaseEnglishName,
                diseaseRemarkChinese,
                diseaseRemarkEnglish,
                clinicalRoleName,
                clinicalRoleEnglishName,
                clinicalTypeName,
                clinicalTypeEnglishName,
                clinicalStartTime,
                clinicalEndTime,
                investigationProductName,
                investigationProductEnglishName,
                investigationProductStageName,
                investigationProductStageEnglishName,
                investigationProductStageRemarkChinese,
                investigationProductStageRemarkEnglish,
            } = item;
            const diseaseRemark = isChinese ? diseaseRemarkChinese : diseaseRemarkEnglish;
            const investigationProductStageRemark = isChinese ? investigationProductStageRemarkChinese : investigationProductStageRemarkEnglish;
            return {
                index: index + 1,
                ...item,
                investigationAreaName: isChinese ? investigationAreaName : investigationAreaEnglishName,
                diseaseName: `${isChinese ? diseaseName : diseaseEnglishName}${diseaseRemark ? `(${diseaseRemark})` : ''}`,
                clinicalRoleName: isChinese ? clinicalRoleName : clinicalRoleEnglishName,
                clinicalTypeName: isChinese ? clinicalTypeName : clinicalTypeEnglishName,
                joinTime: `${clinicalStartTime.slice(0, 7)}~${clinicalEndTime ? clinicalEndTime.slice(0, 7) : isChinese ? '至今' : 'Present'}`,
                investigationProductName: isChinese ? investigationProductName : investigationProductEnglishName,
                investigationProductStageName: `${isChinese ? investigationProductStageName : investigationProductStageEnglishName}${investigationProductStageRemark ? `(${investigationProductStageRemark})` : ''}`,
            }
        });
        return dataSource;
    }

    render() {
        const {
            visible,
            loading,
            user: {
                userCompellation,
                cityName,
                userEmail,
                userDetail,
                userMobile,
                clinicalTrialExperienceYears,
            },
        } = this.state;
        const {
            gender,
            employeeCode,
        } = userDetail || {};
        return (
            <Modal
                title="人员信息"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="800px"
                maskCloseable={false}
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div className="cont-cont" style={{margin:10}}>
                        <h4 style={{ margin: '8px 0 16px' }}>1.个人信息</h4>
                        <table cellPadding='0' cellSpacing='0' className="distribute information">
                            <tbody>
                                <tr>
                                    <td className="distribute_td_left need-bold">姓名：</td>
                                    <td className="distribute_td_right">{userCompellation}</td>
                                    <td className="distribute_td_left need-bold">工号：</td>
                                    <td className="distribute_td_right">{employeeCode}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left need-bold">性别：</td>
                                    <td className="distribute_td_right">{gender == 'FEMALE' ? '女' : '男'}</td>
                                    <td className="distribute_td_left need-bold">工作城市：</td>
                                    <td className="distribute_td_right">{cityName}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left need-bold">手机号码：</td>
                                    <td className="distribute_td_right">{userMobile}</td>
                                    <td className="distribute_td_left need-bold">邮箱：</td>
                                    <td className="distribute_td_right">{userEmail}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left need-bold">从事临床试验的年限(月)：</td>
                                    <td className="distribute_td_right">{clinicalTrialExperienceYears}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 style={{ margin: '8px 0 16px' }}>2.进行中项目</h4>
                        <div style={{ marginBottom: 20 }}>
                            <Table
                                bordered
                                columns={this.getColumns()}
                                dataSource={this.getDataSource()}
                                rowKey={record => record.vitaeClinicalExperienceId}
                                loading={loading}
                                scroll={{ y: 200 }}
                                pagination={false}
                            />
                            <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }}></div>
                        </div>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/UserInfo.js